import * as Styled from '../styled'
import AddIcon from 'assets/svgr-icons/Add_Sound.svg'
import { Tooltip } from 'components/Tooltip'
import { translate } from 'utils/translations'
import { T } from 'consts/translationKeys'
import { IUserAudio } from 'store/types/audio'
import { projectDataThunks } from 'store/features/projectData/thunks'
import { dispatch } from 'store'
import { useCallback } from 'react'
import useAudioLimitCheck from 'hooks/useAudioLimitCheck'
import { editorThunks } from 'store/features/editor/thunks'
import { useResponsive } from 'hooks/useResponsive'
import { SMALL_DESKTOP_SIZE_BREAKPOINT } from 'consts'
import { useTimelineContext } from 'context/TimelineContext'

interface IProps {
  sound: IUserAudio
  onClickAddButton: (() => void) | undefined
}

export const SoundListItemAddButton: React.FC<IProps> = ({
  onClickAddButton,
  sound
}) => {
  const { isAudioDurationAllowed } = useAudioLimitCheck()
  const { getCurrentTimeImmediate } = useTimelineContext()

  const isMobile = useResponsive(SMALL_DESKTOP_SIZE_BREAKPOINT)
  const handleAddSound = useCallback(() => {
    if (
      !isAudioDurationAllowed(sound.duration, {
        checkLineOnly: true,
        lineIndex: 0
      })
    ) {
      return
    }
    const currentTime = getCurrentTimeImmediate()
    dispatch(projectDataThunks.addUserAudioToProject(sound, currentTime))
    onClickAddButton?.()
    if (isMobile) {
      dispatch(editorThunks.setIsMobileSubSidebarOpen(false))
    }
  }, [
    sound,
    onClickAddButton,
    isAudioDurationAllowed,
    isMobile,
    getCurrentTimeImmediate
  ])

  return (
    <Tooltip tooltipText={translate(T.ADD_TO_TIMELINE)}>
      <Styled.IconButtonWrapper onClick={handleAddSound}>
        <AddIcon />
      </Styled.IconButtonWrapper>
    </Tooltip>
  )
}
